module.exports = __webpack_public_path__ + "static/media/5.Router.ccce9e0c.jpg";